import React, { useState, useEffect } from "react";
import { MessageCircle } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";

export default function WhatsAppFloat() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 2000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <AnimatePresence>
      {visible && (
        <motion.a
          initial={{ scale: 0, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          exit={{ scale: 0, opacity: 0 }}
          href="https://wa.me/918976254720?text=Hello%20Food%20Safety%20Partners%2C%20I%20would%20like%20to%20know%20more%20about%20your%20food%20safety%20services."
          target="_blank"
          rel="noopener noreferrer"
          className="fixed bottom-6 right-6 z-50 bg-[#25D366] text-white rounded-full px-5 py-3.5 shadow-lg hover:shadow-xl hover:-translate-y-1 transition-all duration-300 flex items-center gap-2"
          data-testid="whatsapp-float-btn"
        >
          <MessageCircle size={20} />
          <span className="text-sm font-medium hidden sm:inline">WhatsApp</span>
        </motion.a>
      )}
    </AnimatePresence>
  );
}
